(function () {
	const initProductAccordion = () => {
		if (typeof jQuery !== "undefined") {
			$(document).off("click keydown", ".product-about__accordion-title");
			$(document).on("click keydown", ".product-about__accordion-title", function (event) {
				if (event.type === "click" || event.key === "Enter" || event.keyCode === 13) {
					event.preventDefault();
					const $title = $(this);
					const $item = $title.closest(".product-about__accordion-item");
					const $content = $item.find(".product-about__accordion-content");

					if (!$title.hasClass("active")) {
						$(".product-about__accordion-title.active").not($title).removeClass("active");
						$(".product-about__accordion-content").not($content).stop().slideUp(200);
						$title.addClass("active");
						$content.stop().slideDown(200);
					} else {
						$title.removeClass("active");
						$content.stop().slideUp(200);
					}
				}
			});
		} else {
			document.querySelectorAll(".product-about__accordion-title").forEach((title) => {
				title.onclick = function (e) {
					e.preventDefault();
					const item = this.closest(".product-about__accordion-item");
					const content = item ? item.querySelector(".product-about__accordion-content") : null;
					const isActive = this.classList.contains("active");

					document.querySelectorAll(".product-about__accordion-title.active").forEach((t) => {
						if (t !== title) {
							t.classList.remove("active");
							const c = t.closest(".product-about__accordion-item")?.querySelector(".product-about__accordion-content");
							if (c) c.style.display = "none";
						}
					});

					if (!isActive) {
						this.classList.add("active");
						if (content) content.style.display = "block";
					} else {
						this.classList.remove("active");
						if (content) content.style.display = "none";
					}
				};
			});
		}
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initProductAccordion);
	} else {
		initProductAccordion();
	}

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});
})();
